module.exports = __webpack_public_path__ + "img/mt_clickbait_style_film.448c1b15.svg";